<template>
    <modal title="Testing Einstellungen">
        <ion-list>
            <ion-radio-group>
                <ion-list-header>
                    <ion-label>Schnittstelle</ion-label>
                </ion-list-header>
                <ion-item>
                    <ion-label>aemtest2</ion-label>
                    <base-radio
                        self="aemtest2"
                        v-model="schnittstelle"
                    ></base-radio>
                </ion-item>
                <ion-item>
                    <ion-label>aemfach</ion-label>
                    <base-radio
                        self="aemfach"
                        v-model="schnittstelle"
                    ></base-radio>
                </ion-item>
                <ion-item>
                    <ion-label>www (LIVE)</ion-label>
                    <base-radio self="www" v-model="schnittstelle"></base-radio>
                </ion-item>
            </ion-radio-group>
        </ion-list>
        <ion-list>
            <ion-list-header>
                <ion-label>Push Notifications</ion-label>
            </ion-list-header>
            <ion-item>
                <ion-label class="ion-text-wrap">Geräte ID</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">
                    <b slot="end">{{
                        deviceid !== ""
                            ? deviceid
                            : "nicht vorhanden (Push Einstellungen checken)"
                    }}</b></ion-label
                >
                <ion-button
                    class="c-copybutton"
                    fill="clear"
                    @click="copyValue(deviceid, 'Geräte ID')"
                    v-if="deviceid"
                >
                    <ion-icon
                        slot="icon-only"
                        ios="md-copy"
                        md="md-copy"
                    ></ion-icon>
                </ion-button>
            </ion-item>
        </ion-list>
        <template
            v-if="
                ('appVersion' in deviceInfo && deviceInfo.appVersion !== '') ||
                ('appBuild' in deviceInfo && deviceInfo.appBuild !== '')
            "
        >
            <ion-list>
                <ion-list-header>
                    <ion-label>App Informationen</ion-label>
                </ion-list-header>
                <ion-item
                    v-if="
                        'appVersion' in deviceInfo &&
                        deviceInfo.appVersion !== ''
                    "
                >
                    <ion-label>App Version</ion-label>
                    <b slot="end">{{ deviceInfo.appVersion }}</b>
                </ion-item>
                <ion-item
                    v-if="
                        'appBuild' in deviceInfo && deviceInfo.appBuild !== ''
                    "
                >
                    <ion-label>App Build</ion-label>
                    <b slot="end">{{ deviceInfo.appBuild }}</b>
                </ion-item>
            </ion-list>
        </template>
        <ion-button
            class="ion-margin-top"
            expand="block"
            fill="outline"
            @click="shareLog"
            >Gesamten Log teilen</ion-button
        >
        <ion-button
            class="ion-margin-top"
            expand="block"
            fill="outline"
            @click="debugHeader"
            >Debug Header</ion-button
        >
        <template v-slot:footer>
            <ion-button expand="block" @click="save()">Speichern</ion-button>
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";
import { setEnvironment } from "@/utils/environment";
import BaseRadio from "@/components/BaseRadio";
import { Plugins } from "@capacitor/core";
import { axios } from "@/plugins/axios";

const {
    Share,
    Device,
    // UrbanAirshipPlugin,
    Clipboard,
} = Plugins;

export default {
    components: {
        Modal,
        BaseRadio,
    },
    props: {},
    data() {
        return {
            schnittstelle: "",
            deviceInfo: {},
            deviceid: undefined,
        };
    },
    mounted() {
        Device.getInfo().then((info) => {
            this.deviceInfo = info;
        });
        if (this.$store.state.baseurl === "") {
            this.schnittstelle = "www";
        } else {
            this.schnittstelle = this.$store.state.baseurl;
        }
        // UrbanAirshipPlugin.getUADeviceid().then((deviceidObject) => {
        //     if ("value" in deviceidObject) {
        //         this.deviceid = deviceidObject.value;
        //     } else {
        //         this.deviceid = "";
        //     }
        // });
    },
    methods: {
        debugHeader() {
            axios.get("?Mode=General&Function=DebugHeader");
        },
        save() {
            let schnittstelle = this.schnittstelle;
            if (schnittstelle === "www") {
                schnittstelle = "";
            }
            setEnvironment(schnittstelle);
            this.$ionic.modalController.dismiss();
        },
        async shareLog() {
            Share.share({
                title: "Klickmal App Log",
                text:
                    "Schnittstelle: " +
                    this.schnittstelle +
                    "\n\n" +
                    "Geräteinfos:\n" +
                    JSON.stringify(this.deviceInfo) +
                    "\n\n" +
                    "Log:\n" +
                    JSON.stringify(this.$store.state.developmentLogs),
                dialogTitle: "Klickmal App Log teilen",
            }).catch((error) => {
                this.$ionic.toastController
                    .create({
                        color: "dark",
                        duration: 2000,
                        message: error,
                        showCloseButton: true,
                        closeButtonText: "Schließen",
                    })
                    .then((toast) => {
                        toast.present();
                    });
            });
        },
        copyValue(value, label) {
            Clipboard.write({ string: value }).then(() => {
                this.$ionic.toastController
                    .create({
                        color: "dark",
                        duration: 2000,
                        message: label + " wurde kopiert",
                        showCloseButton: true,
                        closeButtonText: "Schließen",
                    })
                    .then((toast) => {
                        toast.present();
                    });
            });
        },
    },
};
</script>

<style></style>
